import MessageProps from './parts/MessageProps';
import { is } from 'bpmn-js/lib/util/ModelUtil';

const LOW_PRIORITY = 500;

export default class MessagePropertiesProvider {

  constructor(propertiesPanel, translate) {

    this.getGroups = function (element) {
      return function (groups) {
        // Add the new group
        if (is(element, 'bpmn:SendTask')) {
          groups.push(createMessageGroup(element, translate));
        }
        return groups;
      };
    };

    // Use a lower priority to ensure it is loaded after the basic BPMN properties.
    propertiesPanel.registerProvider(LOW_PRIORITY, this);
  }
}

MessagePropertiesProvider.$inject = [ 'propertiesPanel', 'translate' ];

// Create the custom group called "Message".
function createMessageGroup(element, translate) {

  const messageGroup = {
    id: 'message',
    label: translate('Message'),
    entries: MessageProps(element),
    // tooltip: translate('Group tooltip')
  };

  return messageGroup;
}
